
import React from 'react'
import ContentLoader from 'react-content-loader'
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';


const RowLoader = ({
  height, 
  width, 
  marginTop, 
  marginBottom, 
  padding, 
  borderRadius, 
  display,
  verticalAlign,
  forceDark,
  ...props 
}: any) => {
  const { isDarkMode } = useAppSelector((state) => state.windowState);

  const currentHeight = height ? String(height).replace('px', '') : 24;  
  const currentWidth = width ? String(width).replace('px', '') : 140;
  const margintop = marginTop || 0;
  const marginbottom = marginBottom || 0;
  const currentPadding = padding || '12px 0 0 0';
  const borderradius = borderRadius || 0;
  const currentDisplay = display || 'block';
  const currentVerticalAlign = verticalAlign || 'baseline';
  const hasPercentWidth = typeof width === 'string' && width.includes('%');
  const hasPercentHeight = typeof height === 'string' && height.includes('%');
  const shouldUseViewBox = !(hasPercentWidth || hasPercentHeight);

  const { t } = useTranslation();
  const darkMode = forceDark || isDarkMode;
  
  return (
    <div key={props?.key} style={{ 
      padding: currentPadding, 
      overflow: 'hidden', 
      height: currentHeight, 
      marginTop: margintop, 
      marginBottom: marginbottom, 
      borderRadius: borderradius,
      display: currentDisplay,
      verticalAlign: currentVerticalAlign
    }}>
      <ContentLoader 
        backgroundColor={darkMode ? '#303030ff' : '#f5f6f7'}
        foregroundColor={darkMode ? '#101010ff' : '#eee'}
        speed={2}
        width={currentWidth}
        height={currentHeight}
        title={t('Documents.table.loader')}
        {...shouldUseViewBox && {viewBox: `0 0 ${currentWidth} ${currentHeight}`}}

      >
        <rect x='0' y='0' rx='3' ry='3' width={currentWidth} height={currentHeight} />
      </ContentLoader>
    </div>
  )
}

export default RowLoader
